'use client';

import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';

export type AnimationStateType = 'enter' | 'idle' | 'exit';

export function useAnimationState() {
  const pathname = usePathname();
  const [animationState, setAnimationState] =
    useState<AnimationStateType>('enter');

  useEffect(() => {
    setAnimationState('enter');
    const enterTimeout = setTimeout(() => {
      setAnimationState('idle');
    }, 50);

    return () => {
      clearTimeout(enterTimeout);
      setAnimationState('exit');
    };
  }, [pathname]);

  return animationState;
}
